import Vue from 'vue'
import SvgIcon from '@/components/svgIcon/svgIcon.vue'
// Global registration component
Vue.component('svg-icon', SvgIcon)
// Define a feature to load the directory
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('@/assets/svg', false, /\.svg$/)
// Load all SVG files in the directory
requireAll(req)
